import React from 'react';
import CreateTagIcon from '../../../../../../image/create-tag.svg';
import css from './TagCreationForm.module.scss';

interface TagCreationFormProps {
	tagName: string;
	onTagNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	handleCreateTag: () => void;
}

export const TagCreationForm: React.FC<TagCreationFormProps> = ({
	tagName,
	onTagNameChange,
	handleCreateTag,
}) => (
	<div className={css.create_tag}>
		<div className={css.create_tag_icon}>
			<CreateTagIcon />
		</div>
		<input
			placeholder="Создать тег"
			className={css.input}
			value={tagName}
			onChange={onTagNameChange}
		/>
		{
			tagName.length >= 2 && (
				<button
					type="button"
					className={css.button}
					onClick={handleCreateTag}
				>
					Сохранить
				</button>
			)
		}
	</div>
);
